import { CalendarCheck } from "lucide-react";

export const ShineButton = ({ children, onClick, type = "button", testId, className = "", disabled, icon = true }) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    data-testid={testId}
    className={`group btn-shine inline-flex items-center justify-center gap-2 rounded-full bg-berenjena px-6 py-4 text-[12px] font-bold uppercase tracking-[0.12em] text-paper transition-[transform,background-color,color] duration-300 hover:bg-gato hover:scale-[1.03] active:scale-95 disabled:opacity-60 ${className}`}
  >
    {icon && <CalendarCheck size={16} className="relative z-[2]" />}
    <span className="relative z-[2]">{children}</span>
  </button>
);
